import React, {Component} from 'react'
import Helmet from 'react-helmet'
import {Grid} from 'react-bootstrap'
import Elm from 'react-elm-components'
import ElmMain from '../../elm/src/Notifications.elm'
import i18n from '../i18n'
import {connect} from 'react-redux'
import {fetchOpeningTicketPurposeRef} from '../reference/actions'
import {linkFinder} from '../core/links'

class NotificationsLayout extends Component {
    setupPorts = (ports) => {
        const {companyId} = this.props
        fetchOpeningTicketPurposeRef(companyId)
            .then(({json}) => {
                ports.otpsReceived.send(json)
            })
    }

    render() {
        const listUrl = this.props.links.find(linkFinder('ticketeventnotifications')).href
        return (
            <div>
                <div>
                    <Helmet title={i18n.notifications} />
                    <Grid>
                        <Elm src={ElmMain.Elm.Main} flags={{listUrl}} ports={this.setupPorts}/>
                    </Grid>
                </div>
            </div>
        )
    }
}

export default connect((state) => ({
    companyId: state.company.company.uid,
    links: state.company.company._links
}))(NotificationsLayout)


// WEBPACK FOOTER //
// ./lib/notifications/NotificationsLayout.js